import Q from 'q';

import API from 'js/lib/api';

import type ProfilesV1 from 'bundles/naptimejs/resources/profiles.v1';

type updateUserProfileType = (
  data: Record<string, unknown>,
  applyPipelineValidation?: boolean
) => Q.Promise<{ data: ProfilesV1 }>;

export const updateUserProfile: updateUserProfileType = (data) => {
  const api = API('', { type: 'rest' });

  return Q(api.put(`/api/profiles.v1/${data.userId}`, { data }));
};
